import produce from 'immer';
import { Actions } from './action';
import { AppActions } from './enum';
import { AppState } from './interface';
import {
    handleAfterVpLinkReset,
    handleInitStore,
    handleProviderReset,
    handleSetAvcResult,
    handleSetTariffs,
    setSelectedByID,
} from './util/reducer';
import { OverlayContent } from '../../enums/elementId';
import { ProviderType } from '../../enums/product';

export const initialState: AppState = {
    loading: false,
    address: undefined,
    error: undefined,
    familyAndFriends: false,
    gigakombi: false,
    activeProviderType: ProviderType.TELEKOM,
    selected: {
        tariffId: 'FIB-BSA-IP-1000',
        tariff: undefined,
    },
    tariffs: {
        [ProviderType.TELEKOM]: [],
        [ProviderType.VODAFONE]: [],
    },
    avcResult: undefined,
    overlayLoaded: false,
    isOverlayOpen: false,
    activeOverlay: OverlayContent.FORM,
    userInfo: undefined,
    isAutoOverlayOpened: false,
};

const appReducer = (state: AppState = initialState, action: Actions) =>
    produce(state, (draft) => {
        switch (action.type) {
            case AppActions.INIT_STORE:
                handleInitStore(draft, action.payload);
                break;
            case AppActions.SET_LOADING:
                draft.loading = action.loading;
                break;
            case AppActions.ERROR:
                draft.error = action.error;
                draft.loading = false;
                break;
            case AppActions.SET_ADDRESS:
                draft.address = action.address;
                draft.loading = false;
                break;
            case AppActions.DELETE_ADDRESS:
                draft.address = undefined;
                draft.avcResult = undefined;
                draft.preMarketing = undefined;
                break;
            case AppActions.SET_TARIFFS:
                handleSetTariffs(draft, action.tariffs);
                break;
            case AppActions.SET_FAMILY_AND_FRIENDS:
                draft.familyAndFriends = action.familyAndFriends;
                break;
            case AppActions.SET_ACTIVE_PRODUCT_TYPE:
                draft.activeProviderType = action.activeProviderType;
                break;
            case AppActions.SET_SELECTED_TARIFF:
                setSelectedByID(draft, action.id);
                break;
            case AppActions.SET_GIGAKOMBI:
                draft.gigakombi = action.gigakombi;
                break;
            case AppActions.SET_AVC_RESULT:
                handleSetAvcResult(draft, action.result);
                break;
            case AppActions.OVERLAY_LOADED:
                draft.overlayLoaded = true;
                break;
            case AppActions.OPEN_OVERLAY:
                draft.activeOverlay = action.payload.overlayWrapper;
                draft.isOverlayOpen = true;
                draft.isAutoOverlayOpened = action.payload.openAutoOverlay;
                break;
            case AppActions.CLOSE_OVERLAY:
                draft.isOverlayOpen = false;
                break;
            case AppActions.SET_ACTIVE_OVERLAY:
                draft.activeOverlay = action.activeOverlay;
                break;
            case AppActions.RESET_PROVIDER:
                handleProviderReset(draft, initialState);
                break;
            case AppActions.RESET_TARIFFS:
                handleAfterVpLinkReset(draft);
                break;
            case AppActions.SET_USER_INFO:
                draft.userInfo = action.userInfo;
                break;
            case AppActions.SET_PRE_MARKETING:
                draft.preMarketing = action.preMarketing;
                break;
        }
    });

export default appReducer;
